var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('indicator-value-value');
import { breakpoints, theme } from '@shapeable/theme';
import { Content } from '../elements/content';
import { Icon } from '../elements/icon';
import { keys, includes } from 'lodash';
import { Icons } from '../icons'; // -------- Constants ----->

export var INDICATOR_VALUE_VALUE_UNIT_CONVERSIONS = {
  'm2': 'm<sup>2</sup>',
  'mi2': 'mi<sup>2</sup>',
  'm3': 'm<sup>3</sup>',
  'mi3': 'mi<sup>3</sup>'
};
export var INDICATOR_VALUE_VALUE_TRUE_VALUES = ['Y', 'YES', '1'];
export var indicatorValueUnitConvert = function indicatorValueUnitConvert(text) {
  return keys(INDICATOR_VALUE_VALUE_UNIT_CONVERSIONS).reduce(function (acc, key) {
    return acc.replace(key, INDICATOR_VALUE_VALUE_UNIT_CONVERSIONS[key]);
  }, text || '');
};
export var IndicatorValueValueDefaultProps = {
  emptyValue: '–'
}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(15))
});
var PrefixStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SuffixStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    display: inline-block;\n    padding-left: ", ";\n  "], ["\n    color: ", ";\n    display: inline-block;\n    padding-left: ", ";\n  "])), theme.COLOR('text-subtle'), theme.UNIT(1))
});
var IconStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Prefix: styled(Content).attrs({
    inline: true
  })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), PrefixStyles),
  Suffix: styled(Content).attrs({
    inline: true
  })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), SuffixStyles),
  Icon: styled(Icon)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var IndicatorValueValue = function IndicatorValueValue(props) {
  var className = props.className,
      _a = props.unit,
      unit = _a === void 0 ? {
    id: ''
  } : _a,
      value = props.value,
      numericValue = props.numericValue,
      emptyValue = props.emptyValue;
  var prefix = unit.prefix,
      suffix = unit.suffix,
      _b = unit.valueType,
      valueType = _b === void 0 ? {
    slug: 'number'
  } : _b;
  var TrueIcon = Icons.Tick;
  var FalseIcon = Icons.Cross;
  var displayValue = value;
  var precision = props.precision === undefined || props.precision === null ? 3 : props.precision;

  if (valueType.slug === 'number' && numericValue !== undefined) {
    displayValue = numericValue.toFixed(precision);
  }

  if (valueType.slug === 'boolean') {
    if (includes(INDICATOR_VALUE_VALUE_TRUE_VALUES, value.toUpperCase())) {
      displayValue = React.createElement(My.Icon, {
        title: value,
        size: 18
      }, React.createElement(TrueIcon, null));
    } else {
      displayValue = React.createElement(My.Icon, {
        title: value,
        size: 18
      }, React.createElement(FalseIcon, null));
    }
  }

  if (!value) {
    displayValue = emptyValue;
  }

  var showPreSuf = displayValue !== emptyValue;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, prefix && showPreSuf && React.createElement(My.Prefix, {
    html: indicatorValueUnitConvert(prefix)
  }), displayValue, suffix && showPreSuf && React.createElement(My.Suffix, {
    html: indicatorValueUnitConvert(suffix)
  }));
};
IndicatorValueValue.defaultProps = IndicatorValueValueDefaultProps;
IndicatorValueValue.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;